import { EdgeProps } from "reactflow";
import EdgeBaseWrapper from "./EdgeBaseWrapper";
import { memo } from "react";

const FlowGlobalEdge = (props: EdgeProps) => {
  const gradientId = "gradientId";
  const selectedGradientId = `selected-gradient-${props.id}`;

  const edgeStyle = {
    stroke: props.selected
      ? `url(#${selectedGradientId})`
      : `url(#${gradientId})`,
    strokeDasharray: "none",
    strokeWidth: props.selected ? 9 : 7,
  };

  return (
    <EdgeBaseWrapper {...props} style={edgeStyle}>
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="white" />
          <stop offset="100%" stopColor="blue" />
        </linearGradient>
        {props.selected && (
          <linearGradient
            id={selectedGradientId}
            x1="0%"
            y1="0%"
            x2="100%"
            y2="0%"
          >
            <stop offset="0%" stopColor="#3650DE" />
            <stop offset="100%" stopColor="#3650DE" />
          </linearGradient>
        )}
      </defs>
    </EdgeBaseWrapper>
  );
};

export default memo(FlowGlobalEdge);
